// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"cac00ac0","507":"776ce8aa","560":"f18bb091","578":"086ec6aa"}[chunkId] + ".chunk.js";
};